module.exports = __webpack_public_path__ + "img/T6-A-xs_3.7f42d86b.png";